import { PRODUCT_LIST } from '../../mutationTypes'

const mutations = {
  [PRODUCT_LIST](state, action){
    state.items = action.items
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/product/productMutations.js